<template>
  <form @submit.prevent="submit" class="add-domain-modal">
    <span class="kw kw-x" @click="close" />
    <p class="title">{{ getTitle }}</p>

    <kw-input-field
      v-model.trim="domain"
      :label="$t('domain-name')"
      name="domain"
      :placeholder="`${$t('enter-domain-to-track')}`"
      :disabled="loading"
    />

    <kw-button
      :button-text="$t('add-domain')"
      :button-classes="'rankscale'"
      button-type="primary"
      @click="submit"
      :loading="loading"
      :buttonDisabled="!domain"
    />
  </form>
</template>

<script>
import { mapActions } from 'vuex';
import ClickOutside from 'vue-click-outside';

export default {
  name: 'AddAiVisibilityDomain',
  directives: {
    ClickOutside,
  },
  props: {
    title: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      domain: '',
      loading: false,
    };
  },
  computed: {
    getTitle() {
      return this.title ?? this.$t('add-domain');
    },
  },
  methods: {
    ...mapActions(['addAiVisibilityDomain']),
    getOrigin(url) {
      const match = url.match(/^(?:https?:\/\/)?([^\/]+)/i);
      return match ? match[1].replace('www.', '') : null;
    },
    submit() {
      this.loading = true;
      this.addAiVisibilityDomain(this.getOrigin(this.domain))
        .then((res) => {
          if (res) {
            this.close();
            this.$router.push(`/ai-visibility/${res.id}`);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~sass/modal';
.add-domain-modal {
  position: relative;
  width: 100%;
  padding: 14px 16px 16px;
  p.title {
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 24px;
    line-height: 100%;
  }
  ::v-deep .kw__inputfield .field__label {
    font-size: 13px;
  }
  & > button.rankscale {
    width: 144px;
    margin-top: 24px;
  }
  .kw-x {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 7px;
    right: 7px;
    font-size: 10px;
    width: 16px;
    height: 16px;
    cursor: pointer;
    font-weight: 900;
    color: kw-color(kw-light-grey, 4);
  }
}
</style>
